const initLearningPlans = () => {
  const learningPlansModules = document.querySelector('.learning-plans');

  if (!learningPlansModules) {
    return;
  }

  const filterButtons = learningPlansModules.querySelectorAll('.learning-plans__filter-button');
  const listItems = learningPlansModules.querySelectorAll('.learning-plans__list-item');

  const learningItems = learningPlansModules.querySelectorAll('.learning-plans__item');

  learningItems.forEach(group => {
    const items = group.querySelectorAll('.learning-plans__list-item[data-id="required"]');
    const noContent = group.querySelector('.learning-plans__no-content');
    const title = group.querySelector('.learning-plans__item-title');
    
    let visibleCount = 0;

    items.forEach(item => {
      if (item.style.display !== 'none') {
        visibleCount++;
      }
    });

    if (visibleCount === 0) {
      title.style.display = 'none';
    }
  });

  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      const filter = button.getAttribute('data-filter');

      filterButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      listItems.forEach((item) => {
        const itemCategory = item.getAttribute('data-id');
        const itemQuarter = item.getAttribute('data-quarter');

        let shouldShow = false;

        if (filter === 'all') {
          shouldShow = true;
        } else if (filter === 'required') {
          shouldShow = itemCategory === 'required';
        } else if (filter === 'q1' || filter === 'q2' || filter === 'q3' || filter === 'q4') {
          shouldShow = itemQuarter === filter && itemCategory === 'required';
        }

        item.style.display = shouldShow ? 'block' : 'none';
      });

      const learningItems = learningPlansModules.querySelectorAll('.learning-plans__item');

      learningItems.forEach(group => {
        const items = group.querySelectorAll('.learning-plans__list-item');
        const noContent = group.querySelector('.learning-plans__no-content');
        const title = group.querySelector('.learning-plans__item-title');

        let matchCount = 0;

        items.forEach(item => {
          const itemCategory = item.getAttribute('data-id');
          const itemQuarter = item.getAttribute('data-quarter');

          let matches = false;

          if (filter === 'all') {
            matches = true;
          } else if (filter === 'required') {
            matches = itemCategory === 'required';
          } else if (filter === 'q1' || filter === 'q2' || filter === 'q3' || filter === 'q4') {
            matches = itemCategory === 'required' && itemQuarter === filter;
          }

          if (matches) {
            matchCount++;
          }
        });

        if (matchCount === 0) {
          // noContent.style.display = 'block';

          if (filter === 'all') {
            title.style.display = 'block';
          } else {
            title.style.display = 'none';
          }
        } else {
          noContent.style.display = 'none';
          title.style.display = 'block';
        }
      });
    });
  });

  learningPlansModules.addEventListener('click', (e) => {
    const button = e.target.closest('.learning-plans__list-item-link');

    if (!button || !learningPlansModules.contains(button)) {
      return;
    }

    const url = button.getAttribute('data-href');
    const platform = button.getAttribute('data-platform');
    const area = button.getAttribute('data-area');
    const activatePage = document.querySelector('.agcollege-modal__activate');
    const proceedPage = document.querySelector('.agcollege-modal__proceed');
    
    const externalBtn = document.querySelector('.external-modal__continue-button');
    externalBtn.setAttribute('href', url || '#');
    proceedPage.setAttribute('href', url || '#');

    if (activatePage) {
      const activateUrl = new URL(activatePage.getAttribute('href'), window.location.origin);
      activateUrl.searchParams.set('url', url || '');
      activateUrl.searchParams.set('platform', platform || '');
      activateUrl.searchParams.set('area', area || '');
      activatePage.setAttribute('href', activateUrl.toString());
    }
  });

  const quarterButtons = learningPlansModules.querySelectorAll('.quarter-button');
  let q1Button = 0;
  let q2Button = 0;
  let q3Button = 0;
  let q4Button = 0;

  listItems.forEach(item => {
    const quarter = item.getAttribute('data-quarter');

    if (quarter === 'q1') {
      q1Button++;
    } else if (quarter === 'q2') {
      q2Button++;
    } else if (quarter === 'q3') {
      q3Button++;
    } else if (quarter === 'q4') {
      q4Button++;
    }
  });

  quarterButtons.forEach(button => {
    const filter = button.getAttribute('data-filter');

    if (filter === 'q1' && q1Button === 0) {
      button.style.display = 'none';
    } else if (filter === 'q2' && q2Button === 0) {
      button.style.display = 'none';
    } else if (filter === 'q3' && q3Button === 0) {
      button.style.display = 'none';
    } else if (filter === 'q4' && q4Button === 0) {
      button.style.display = 'none';
    }
  });

  const continueButton = document.querySelector('.agcollege-modal__continue-button');
  continueButton.addEventListener('click', () => {
    const closeButton = document.querySelector('.agcollege-modal .uk-modal-close');
    closeButton.click();
  });
};

export default initLearningPlans;